// `insertLineBreak` (useMentionEditor) plants one of these right after a
// `<br>` it inserts — a Chrome quirk resolves a caret placed directly on an
// empty text node back to just *before* the `<br>`, so typing continues on
// the old line instead of the new one. A zero-width space gives the caret a
// real character to sit after. It's excluded from logical offsets/length in
// `clipboard.ts` and stripped in `serializeEditor` so it never leaks into
// saved text.
export const LINE_BREAK_CARET_ANCHOR = '\u200b';

export const withoutCaretAnchor = (value: string): string =>
  value.replaceAll(LINE_BREAK_CARET_ANCHOR, '');

/** Maps a logical (anchor-stripped) offset back to a raw offset into `value`. */
export const rawTextOffset = (value: string, logicalOffset: number): number => {
  let raw = 0;
  let logical = 0;
  while (raw < value.length && logical < logicalOffset) {
    if (value[raw] !== LINE_BREAK_CARET_ANCHOR) {
      logical++;
    }
    raw++;
  }
  while (value[raw] === LINE_BREAK_CARET_ANCHOR) {
    raw++;
  }
  return raw;
};

/** The inverse of `rawTextOffset` — counts non-anchor chars before `rawOffset`. */
export const logicalTextOffset = (value: string, rawOffset: number): number =>
  withoutCaretAnchor(value.slice(0, rawOffset)).length;
